import { AvailableStock, StoreId, StoreName, Total } from '../Constants/Configuration'

const retrieveVariantsBasedOnFilter = (enableAllVariant, quantities) => {
  return enableAllVariant
    ? quantities && quantities.length !== 0
      ? [...quantities]
      : []
    : quantities && quantities.length !== 0
    ? quantities.slice(0, 1)
    : []
}

const retrieveSortedSizes = (quantitiesVariants, unlockHandling) => {
  const sizes = []
  quantitiesVariants.forEach(variant => {
    if (!unlockHandling) {
      if (variant.stores && variant.stores.length !== 0) {
        variant.stores.forEach(store => {
          const storeObjKeys = Object.entries(store)
          storeObjKeys.forEach(([storeKey, storeValue]) => {
            const storeValueArray = storeValue as any[]
            if (storeKey !== StoreName && storeKey !== StoreId) {
              storeValueArray.forEach(sizeAvailability => {
                if (sizeAvailability.name !== Total) {
                  if (sizes.filter(element => element.sizeId === sizeAvailability.sizeId).length === 0) {
                    sizes.push(sizeAvailability)
                  }
                }
              })
            }
          })
        })

        //if no size is map from filters add all sizes
        if (sizes.length === 0) {
          addResultSizesToSizeArray(variant.sizes, sizes)
        }
      } else {
        //Set all size available for selected article
        addResultSizesToSizeArray(variant.sizes, sizes)
      }
    } else {
      //Set all size available for selected article
      addResultSizesToSizeArray(variant.sizes, sizes)
    }
  })

  sizes.sort((a, b) => {
    return a.order - b.order
  })

  return sizes
}

const retrieveActiveStoreKeysSortByCurrentFilter = (activeStoreKeys, currentFilters) => {
  return activeStoreKeys
    .filter(storeKey => currentFilters.indexOf(storeKey) !== -1)
    .sort((a, b) => {
      return currentFilters.indexOf(a) - currentFilters.indexOf(b)
    })
}

const checkIfStoreHasStockOrAvailability = store => {
  const existingStockSizeValue = store[AvailableStock]
  const availableStockSizeValue = store[AvailableStock]
  return (
    existingStockSizeValue.find(x => x.name === Total && x.quantity > 0) ||
    availableStockSizeValue.find(x => x.name === Total && x.quantity > 0)
  )
}

/*PRIVATE*/
const addResultSizesToSizeArray = (resultSizes, sizes) => {
  if (resultSizes && resultSizes.length !== 0) {
    resultSizes.forEach(size => {
      if (!sizes.find(element => element.sizeId === size.sizeId)) {
        sizes.push(size)
      }
    })
  }
}

export {
  retrieveVariantsBasedOnFilter,
  retrieveSortedSizes,
  retrieveActiveStoreKeysSortByCurrentFilter,
  checkIfStoreHasStockOrAvailability,
}
